<template>
  <div v-click-outside="handleClickOutside">
    <div @click="toggleIsShowSortList" class="sort-header">
      <div class="sort-header__placeholder">
        {{
          selectedOption.text ? selectedOption.text : sortToolConfig.placeholder
        }}
      </div>
      <div class="sort-header__icon">
        <fa icon="sort"></fa>
      </div>
    </div>
    <div v-if="isShowSortList" class="sort-list">
      <Spinner v-if="isSorting" :fullscreen="true">Sorting</Spinner>
      <div
        v-for="(sortTool, index) in sortToolConfig.sortToolList"
        :key="index"
        class="sort-list__wrapper"
      >
        <div
          @click="changeSortIndex(index)"
          class="sort-list__title"
          :class="{ 'darker-bg': activeIndex === index }"
        >
          <div>{{ sortTool.title }}</div>
          <div class="icon" :class="{ rotate: activeIndex === index }">
            <fa icon="chevron-down"></fa>
          </div>
        </div>
        <div v-if="activeIndex === index" class="sort-list__option-group">
          <div v-for="option in sortTool.optionList" :key="option.id">
            <div @click="selectSortOption(option.id)" class="option">
              {{ option.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as vClickOutside from 'v-click-outside';
import Spinner from '../../../ui/Spinner.vue';

export default {
  name: 'MobileSortTool',
  components: { Spinner },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    sortToolConfig: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeIndex: 0,
      isShowSortList: false,
      isSorting: false,
      selectedOption: {
        id: null,
        text: ''
      }
    };
  },
  methods: {
    toggleIsShowSortList() {
      this.isShowSortList = !this.isShowSortList;
    },
    changeSortIndex(index) {
      if (this.activeIndex === index) {
        this.activeIndex = null;
      } else {
        this.activeIndex = index;
      }
    },
    selectSortOption(optionId) {
      this.isSorting = true;
      setTimeout(() => {
        this.isSorting = false;
        this.toggleIsShowSortList();
      }, 500);

      this.selectedOption = this.sortToolConfig.sortToolList[
        this.activeIndex
      ].optionList.find(item => item.id === optionId);

      this.$emit('onSortChange', optionId);
    },
    handleClickOutside() {
      this.isShowSortList = false;
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.sort-header {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  width: 15rem;
  height: 2.5rem;
  border: 1px solid $text-grey;
  background-color: #fff;
  color: $text-black;
}

.sort-list {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-width: 14rem;
  border: 1px solid $text-grey;
  background-color: #fff;
  color: $text-black;

  &__wrapper {
    border-top: 1px solid $text-grey;

    &:nth-child(1) {
      border-top: none;
    }
  }

  &__title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    height: 3rem;
    cursor: pointer;

    &.darker-bg,
    &:hover {
      background-color: $border-grey;
      // background-color: $text-grey;
    }

    .icon.rotate {
      transform: rotateZ(180deg);
    }
  }

  &__option-group {
    padding: 0 1rem;

    .option {
      width: 100%;
      height: 3rem;
      line-height: 3rem;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
